var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.239,
    height: 39.18,
    viewBox: "0 0 68.239 39.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    d: "M53.671,18.563,35.108,0,16.4,18.707a3.26,3.26,0,0,0,4.61,4.61L31.955,12.373V64.981a3.258,3.258,0,1,0,6.516,0v-52.4L49.062,23.173a3.26,3.26,0,1,0,4.61-4.61",
    transform: "translate(68.239 -15.447) rotate(90)",
    fill: "#1d9a9a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/arrow2.8f628fc7dee7254c1b7ccf4e9092161d.svg";
export { ForwardRef as ReactComponent };